import { ActivityWorkflowState, LastActivityWorkflow } from '@/api/models/aggregate'

export const workflowStateUtils = {
  isFinished: (workflow: LastActivityWorkflow | null | undefined) =>
    workflow?.state === ActivityWorkflowState?.finished,
  isGrading: (workflow: LastActivityWorkflow | null | undefined) =>
    workflow?.state === ActivityWorkflowState?.inGrading,
  isInProgress: (workflow: LastActivityWorkflow | null | undefined) =>
    workflow?.state === ActivityWorkflowState?.inProgress,
  isNotStarted: (workflow: LastActivityWorkflow | null | undefined) => !workflow,
}
